import { observer } from "mobx-react-lite"

import { CodingGuidelinesDialogContent } from "@/components/CodingGuidelinesDialog/CodingGuidelinesDialogContent.tsx"
import { CodingGuidelinesDialogModel } from "@/components/CodingGuidelinesDialog/CodingGuidelinesDialogModel.ts"
import { Dialog } from "@/components/Dialog/Dialog.tsx"
import { useModel } from "@/hooks/useModel.ts"
import { useQueries } from "@/hooks/useRootContext.ts"

import type { PR_Project2 } from "@/lib/client/generated/TypeDefinitions.ts"

export const CodingGuidelinesDialog = observer(({ project, open, onOpenChange }: {
  project: PR_Project2
  open: boolean
  onOpenChange: (open: boolean) => void
}) => {
  const queries = useQueries()
  const model = useModel(() => new CodingGuidelinesDialogModel(project, queries), [project, queries])

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      trigger={null}
      title="Coding Guidelines"
    >
      <CodingGuidelinesDialogContent model={model} />
    </Dialog>
  )
})
